import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'

export type DepthTierSelectProps = {
  value: '18m' | '30m' | '30m+' | ''
  onChange: (value: '18m' | '30m' | '30m+') => void
  error?: boolean
  helperText?: string
  disabled?: boolean
}

const depthOptions = [
  { value: '18m', label: '≤18 metres' },
  { value: '30m', label: '≤30 metres' },
  { value: '30m+', label: '>30 metres' }
] as const

const DepthTierSelect = ({
  value,
  onChange,
  error,
  helperText,
  disabled
}: DepthTierSelectProps) => {
  return (
    <TextField
      select
      label='Depth Tier'
      value={value}
      onChange={e => onChange(e.target.value as '18m' | '30m' | '30m+')}
      error={error}
      helperText={helperText}
      fullWidth
      disabled={disabled}
    >
      {depthOptions.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  )
}

export default DepthTierSelect
